import { render, staticRenderFns } from "./TabsGeneral.vue?vue&type=template&id=5f32fcfa"
import script from "./TabsGeneral.vue?vue&type=script&lang=js"
export * from "./TabsGeneral.vue?vue&type=script&lang=js"
import style0 from "./TabsGeneral.vue?vue&type=style&index=0&id=5f32fcfa&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports